import { useQuery } from 'react-query';

import { getPaymentPlansRoute } from '@features/payments';
import { paymentPlansKey } from '@features/payments/constants';
import axiosInstance from '@server/axiosInstance';

export const useGetPaymentPlans = () => {
  const { data: paymentPlansData, isLoading: isLoadingPaymentPlansData } =
    useQuery([paymentPlansKey], {
      queryFn: () =>
        axiosInstance.get(getPaymentPlansRoute).then((res) => res.data),
    });

  return {
    paymentPlansData,
    isLoadingPaymentPlansData,
  };
};
